import { Component, Input } from '@angular/core';

import { Plan } from '../signup-api.service';

// What a plan includes, inside the plan buttons of the signup and of the Área do Cliente.
@Component({
    selector: 'app-plan-card',
    template: `
      <h3>{{ plan.name }}</h3>
      <div class="price">{{ plan.price === 0 ? 'Grátis' : 'R$ ' + plan.price }}@if (plan.price > 0) {<small>/mês</small>}</div>
      <ul>
        <li>{{ plan.monthly_orders_limit ? 'Até ' + plan.monthly_orders_limit + ' pedidos/mês' : 'Pedidos ilimitados' }}</li>
        <li>Cardápio digital{{ plan.monthly_menu_views_limit ? ' (' + plan.monthly_menu_views_limit + ' visitas/mês)' : '' }}</li>
        <li>Site de reservas{{ plan.monthly_reservation_views_limit ? ' (' + plan.monthly_reservation_views_limit + ' visitas/mês)' : '' }}</li>
        <li [class.no]="!plan.online_orders_site">Site de delivery</li>
        <li [class.no]="!plan.evaluations_site">Site de avaliações</li>
        <li [class.no]="!plan.whatsapp_confirmations">Confirmações por WhatsApp</li>
        <li [class.no]="!plan.selfservice">Autoatendimento</li>
        <li>{{ plan.priority_support ? 'Suporte prioritário' : 'Suporte automatizado e por e-mail' }}</li>
      </ul>
    `,
    styles: [`
      h3 { font-size: 1.1em; margin: 0; }
      .price { font-size: 1.5em; font-weight: 700; margin: 0.2em 0 0.4em; }
      ul { padding-left: 1.1em; margin: 0; font-size: 0.9em; }
      .no { color: #999; text-decoration: line-through; }
    `],
    standalone: false
})
export class PlanCardComponent {
  @Input({ required: true }) plan!: Plan;
}
